<template>
  <div style="min-height:600px; background-color: white">
    <a-breadcrumb style="padding: 16px 24px">
      <a-breadcrumb-item>
        <router-link :to="{name:'scf'}">
          <a-icon type="home"/>
          <span>首页</span>
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item href="">
        <router-link :to="{name:'news'}">
          <span>新闻</span>
        </router-link>
      </a-breadcrumb-item>
    </a-breadcrumb>

    <a-page-header
      style="border: 1px solid rgb(235, 237, 240)"
      :title="newsInfo.name"
    >
      <a-descriptions size="small" :column="3" v-if="newsInfo">
        <a-descriptions-item label="">
          <a-icon type="team"></a-icon>
          {{ newsInfo.pageview }}
        </a-descriptions-item>
        <a-descriptions-item label="">
          <a-icon type="clock-circle"></a-icon>
          {{ newsInfo.addTime.split('T')[0] }}
        </a-descriptions-item>

      </a-descriptions>

    </a-page-header>

    <!--    <div  id="course-info" v-html="item.desc"></div>-->
    <div style="padding: 16px 24px">
      <div v-html="newsInfo.desc" v-if="newsInfo">
      </div>

      <a-divider/>


      <router-link v-if="newsInfo.before" :to="{name:'newsInfo', params:{id:newsInfo.before.id}}">
        <<< 上一篇 {{ newsInfo.before.name }}
      </router-link>
      <span v-else><<< 上一篇 无</span>
      <router-link class="float-right" v-if="newsInfo.next" :to="{name:'newsInfo', params:{id:newsInfo.next.id}}">
        {{ newsInfo.next.name }} 下一篇 >>>
      </router-link>
      <span class="float-right" v-else>无 下一篇 >>></span>
    </div>


  </div>
</template>

<script>
import {domain, getNewsInfo} from "../../api/api";
import {filterUnderLine} from "../../../static/js/util";

export default {
  name: "NewsInfo",
  props: {id: ''},
  data() {
    return {
      newsInfo: '',
      windowWidth: document.documentElement.clientWidth,
    };
  },
  watch: {
    $route(to, from) {
      if ((to.name === from.name) && (to.path !== from.path)) {
        if (to.params.id !== from.params.id) {
          this.id = to.params.id
          this.toGetInfo(this.id)
        }
      }

    },
    windowWidth(val) {
      if(val <600){
        this.newsInfo.desc = this.newsInfo.desc.replace(/<img src="/g, '<img width="100%" src="')
      }else{
        this.newsInfo.desc = this.newsInfo.desc.replace(/<img width="100%" src="/g, '<img src="')
      }
    }
  },
  mounted() {
    this.toGetInfo(this.id)
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        that.windowWidth = document.documentElement.clientWidth; // 宽
      })()
    }
  },

  methods: {
    toGetInfo(id) {
      getNewsInfo(id)
        .then(res => {
          this.newsInfo = filterUnderLine(res.data)

          let w = document.documentElement.clientWidth;
          if (w < 600) {
            this.newsInfo.desc = this.newsInfo.desc.replace(/<img src="\/scf_media/g, '<img width="100%" src="' + `https://www.hruibo.cn` + '/scf_media')
          } else {
            this.newsInfo.desc = this.newsInfo.desc.replace(/<img src="\/scf_media/g, `<img src="https://www.hruibo.cn/scf_media`)
          }
        })
    }
  }
}
</script>

<style scoped>
a {
  color: var(--primaryColor)
}

a:hover {
  color: blue
}

</style>



// WEBPACK FOOTER //
// src/components/content/NewsInfo.vue